import axios from 'axios'

import store from '@/stores'

import Servico from './Servico'

const URL = process.env.VUE_APP_API_URL

class PacienteServico extends Servico {
  constructor() {
    super('paciente')
  }

  recuperarAgendamentos(data) {
    store.setCarregando()
    const pacienteId = data.pacienteId
    return axios
      .get(`${URL}/${this.path}/${pacienteId}/agendamentos`, { params: data })
      .then((result) => {
        store.setCarregando()
        return result.data
      })
      .catch((err) => {
        store.setCarregando()
        return this.verificarErro(err)
      })
  }

  recuperarGuias(pacienteId, params) {
    store.setCarregando()
    return axios
      .get(`${URL}/${this.path}/${pacienteId}/guias`, { params })
      .then((result) => {
        store.setCarregando()
        return result.data
      })
      .catch((err) => {
        store.setCarregando()
        return this.verificarErro(err)
      })
  }

  recuperarAgendamentosTotal(data) {
    store.setCarregando()
    const pacienteId = data.pacienteId
    return axios
      .get(`${URL}/${this.path}/${pacienteId}/agendamentos/total`, {
        params: data,
      })
      .then((result) => {
        store.setCarregando()
        return result.data
      })
      .catch((err) => {
        store.setCarregando()
        return this.verificarErro(err)
      })
  }

  adicionarDocumentoNoPaciente(idPaciente, idDocumento) {
    store.setCarregando()
    return axios
      .post(`${URL}/${this.path}/${idPaciente}/documentos`, {
        idDocumento: idDocumento,
      })
      .then((result) => {
        store.setCarregando()
        return result.data
      })
      .catch((err) => {
        store.setCarregando()
        return this.verificarErro(err)
      })
  }

  retornarDocumentos(pacienteId) {
    store.setCarregando()
    return axios
      .get(`${URL}/${this.path}/${pacienteId}/documentos`)
      .then((result) => {
        store.setCarregando()
        return result.data
      })
      .catch((err) => {
        store.setCarregando()
        return this.verificarErro(err)
      })
  }

  adicionarEvolucao(pacienteId, data) {
    store.setCarregando()
    return axios
      .post(`${URL}/v2/${this.path}/${pacienteId}/evolucao`, data)
      .then((result) => {
        store.setCarregando()
        return result.data
      })
      .catch((err) => {
        store.setCarregando()
        return this.verificarErro(err, false)
      })
  }

  atualizarEvolucao(pacienteId, evolucaoId, data) {
    store.setCarregando()
    return axios
      .put(`${URL}/v2/${this.path}/${pacienteId}/evolucao/${evolucaoId}`, data)
      .then((result) => {
        store.setCarregando()
        return result.data
      })
      .catch((err) => {
        store.setCarregando()
        return this.verificarErro(err, false)
      })
  }

  recuperarEvolucao(pacienteId, params) {
    store.setCarregando()
    return axios
      .get(`${URL}/v2/${this.path}/${pacienteId}/evolucao`, { params })
      .then((result) => {
        store.setCarregando()
        return result.data
      })
      .catch((err) => {
        store.setCarregando()
        return this.verificarErro(err)
      })
  }

  recuperarPatologiasPregressas(pacienteId, params) {
    store.setCarregando()
    return axios
      .get(`${URL}/v2/${this.path}/${pacienteId}/patologias_pregressas`, {
        params,
      })
      .then((result) => {
        store.setCarregando()
        return result.data
      })
      .catch((err) => {
        store.setCarregando()
        return this.verificarErro(err)
      })
  }

  atualizarPatologiasPregressas(pacienteId, data) {
    store.setCarregando()
    return axios
      .post(`${URL}/v2/${this.path}/${pacienteId}/patologias_pregressas`, data)
      .then((result) => {
        store.setCarregando()
        return result.data
      })
      .catch((err) => {
        store.setCarregando()
        return this.verificarErro(err)
      })
  }
}

export default PacienteServico
